import 'whatwg-fetch'
import { Broker } from './broker'
import { createCmp } from './Cmp'
import Ui from './Ui'
import { createLog } from './logger'
import clientApi from './clientApi'
import { TCString } from '@iabtcf/core'
import loadStorageIframe from './storage-iframe'
import Persist from './Persist'

// https://vendorlist.consensu.org/v2/vendor-list.json

const log = createLog()

async function loadCmp (gvlJson, cvlJson, tcString, storeTcString, customVendorConsents, persist, persistCustomVendors, ui, uuid, gvlVersion, gvlUiVersion) {
  const cmp = await createCmp({ gvlJson, cvlJson, tcString, storeTcString, customVendorConsents, persist, persistCustomVendors, ui, uuid, gvlVersion, gvlUiVersion })
  return { cmp }
}

function createUi (broker, config) {
  const { uiLevel, renderPlatform, brand, uiScriptUrl } = config
  // TODO: this should be uiBroker not clientBroker
  return new Ui({ uiLevel, renderPlatform, brand, uiScriptUrl, clientBroker: broker })
}

function getConfig () {
  const scriptTag = document.getElementById('mol-ads-tcfv2-script')
  const config = JSON.parse(scriptTag.dataset.opts || {})
  log('config', config)
  return config
}

function chooseTcString (stringFromClient, stringFromStorage) {
  log('clientString', stringFromClient)
  log('storedString', stringFromStorage)
  const selectString = () => {
    const stored = TCString.decode(stringFromStorage).lastUpdated
    const client = TCString.decode(stringFromClient).lastUpdated
    log('stored', stored)
    log('client', client)
    return stored > client ? stringFromStorage : stringFromClient
  }

  return stringFromClient && stringFromStorage ? selectString() : stringFromClient || stringFromStorage
}

function chooseCustomVendorsConsents (customVendorsConsentsFromClient, customVendorsConsentsFromStorage) {
  const isEmpty = obj => !Object.keys(obj).length
  // date??
  const clientConsents = customVendorsConsentsFromClient && customVendorsConsentsFromClient.consents || {}
  const storageConsents = customVendorsConsentsFromStorage && customVendorsConsentsFromStorage.consents || {}
  return isEmpty(clientConsents) ? storageConsents : clientConsents
}

async function fetchVendor (url) {
  const response = await fetch(url)
  return response.json()
}
async function fetchVendorData (gvlVersion, cvlVersion = '0.0.1') {
  const gvlUrl = `//cmp.dmgmediaprivacy.co.uk/gvl/${gvlVersion}/vendor-list.json`
  const cvlUrl = `//cmp.dmgmediaprivacy.co.uk/custom/${cvlVersion}/vendor-list.json`
  return Promise.all([fetchVendor(gvlUrl), fetchVendor(cvlUrl)])
}

async function launch (broker, config) {
  let { tcData, iframe, customVendors } = !!config.storeUserPreference && await loadStorageIframe(broker, config.brokerId, config.controllerScriptBase)
  if (!customVendors && config.customVendors && config.customVendors.consents) {
    log('custom vendors not found in store, using provided by site')
    customVendors = config.customVendors
  }
  const tcString = chooseTcString(config.tcString, tcData && tcData.tcString)
  const customVendorsConsents = chooseCustomVendorsConsents(config.customVendors, customVendors)
  const [gvlJson, cvlJson] = await fetchVendorData(config.gvlVersion, config.cvlVersion)
  log('json', gvlJson, cvlJson, customVendorsConsents)
  const persist = new Persist({ backendUrl: config.backendUrl, channel: config.channel })
  const ui = createUi(broker, config)
  const { cmp } = await loadCmp(gvlJson, cvlJson, tcString, config.storeUserPreference, customVendorsConsents, persist, config.persistCustomVendors, ui, config.uuid, config.gvlVersion, config.gvlUiVersion)
  log(`${tcString ? 'Existing' : 'New'} User`, cmp.tcModel)
  const showUi = (config.showUi === 'true' || config.showUi === true)
  broker.emit('is_loaded')
  const message = {
    ns: '@mol-ads/mol-ads-cmp',
    id: config.brokerId,
    sender: 'mol-ads/mol-ads-cmp',
    action: 'is_loaded'
  }
  if (iframe) {
    iframe.contentWindow.postMessage(message, '*')
  }

  await cmp.isReady()
  clientApi(broker, cmp)
  if (showUi) {
    cmp.openUi(config.uiLevel)
  } else {
    cmp.notifyUsersPreferences()
  }
  broker.emit('is_ready')
}

setTimeout(() => {
  const config = getConfig()
  const broker = new Broker('@mol-ads/mol-ads-cmp', 'mol-ads-cmp', config.brokerId)
  launch(broker, config)
}, 10)

// TODO:
// tcf stuff
//
// has user consented:
// Why can't I dynamically set the publisherRestrictions (from the gvl)?
// regenerate the publisherRestrictions ids - ensure we only set 3 / 4 for appropriate vendors
// look into the publisherRestrictions settings - what's stopping them being set?
// refactor the publisher restrictions - also need either the iab lib to be fixed, or publish it ourselves

// move cmp tests to tcModel tests
